import { Typography, IconButton, Button, Radio, FormControlLabel, RadioGroup, Dialog, DialogContent } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/SolicitarPortabilidad.scss';
import React from 'react';
import TextRipleyComponent from './TextRipleyComponent';
import { Info, Close } from '@material-ui/icons';
import { observer } from 'mobx-react';
import * as ValidationUtils from '../../utils/ValidationUtils';
import AutoCompletar from './AutoCompletar';
import ExplicacionCompromisoDeudaComponent from './ExplicacionCompromisoDeudaComponent';

const NUM_CUENTA_MAX_LENGTH = 6;
const SI = 'SI';
const NO = 'NO';
const NO_ESPECIFICADO = 'N/A';

const component = observer(
  class DetalleRotativoComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        montoAdeudado: '',
        montoMaximoDeuda: '',
        montoAprobado: '',
        compromete: NO_ESPECIFICADO,
        numeroCuenta: '',
        openExplicacion: false,
        tipoProducto: {},
      };
    }
    onOpenExplicacion = () => {
      this.setState({ openExplicacion: true });
    };

    onAgregar = () => {
      let producto = {
        codProducto: this.state.tipoProducto.codProducto,
        nombreProducto: this.state.tipoProducto.nombreProducto,
        numeroCuenta: this.state.numeroCuenta,
        montoAprobado: this.state.montoAprobado,
        montoAdeudado: this.state.montoAdeudado,
        compromisoDeuda: this.state.compromete === SI,
        montoMaximoDeuda: this.state.montoMaximoDeuda
      };
      if (this.props.onAgregar) {
        producto = {
          codProducto: this.state.tipoProducto.codProducto,
          nombreProducto: this.state.tipoProducto.nombreProducto,
          numeroCuenta: this.state.numeroCuenta,
          montoAprobado: this.state.montoAprobado,
          montoAdeudado: this.state.montoAdeudado,
          compromisoDeuda: this.state.compromete === SI,
          montoMaximoDeuda: this.state.montoMaximoDeuda,
        };
        this.props.onAgregar(producto);
      }
      if (this.props.onCancelar) {
        this.onCancelar();
      }
    };

    onCancelar = () => {
      if (this.props.onCancelar) {
        this.props.onCancelar();
      }
    };

    onChangeNumCuenta = (evt) => {
      const num = evt.target.value;
      this.setState( (prevState) => {
        let numeroCuenta = prevState.numeroCuenta;
        let errorNumeroCuenta = false;
        let errortxtNumeroCuenta = '';
        if (num.length <= NUM_CUENTA_MAX_LENGTH) {
          if (ValidationUtils.isNumberOrEmpty(num)) {
            numeroCuenta = num;
          }
        }
        if (numeroCuenta.length > 0 && numeroCuenta.length < NUM_CUENTA_MAX_LENGTH) {
          let producto;
          errorNumeroCuenta = true;
          if (prevState.tipoProducto.codProducto === 'TARCRE') {
            producto = 'la tarjeta de crédito';
          } else if (prevState.tipoProducto.codProducto === 'LINCRE') {
            producto = 'la línea de crédito';
          }
          errortxtNumeroCuenta = 'Debes indicar los últimos ' + NUM_CUENTA_MAX_LENGTH + ' dígitos de tu ' + producto;
        }
        return {
          numeroCuenta: numeroCuenta,
          errortxtNumeroCuenta,
          errorNumeroCuenta,
        }
      });
    };

    onChangeMontoMaximoDeuda = (evt) => {
      const num = evt.target.value;
      if (num) {
        const value = ValidationUtils.unformat(num);
        if (ValidationUtils.isNumberOrEmpty(value)) {
          this.setState({
            montoMaximoDeuda: value,
          });
        }
      } else {
        this.setState({
          montoMaximoDeuda: num,
        });
      }
    };

    onChangeMontoAprobado = (evt) => {
      const num = evt.target.value;
      if (num) {
        const value = ValidationUtils.unformat(num);
        if (ValidationUtils.isNumberOrEmpty(value)) {
          this.setState({
            montoAprobado: value,
          });
        }
      } else {
        this.setState({
          montoMaximoDeuda: num,
        });
      }
    };

    onChangeMontoAdeudado = (evt) => {
      const num = evt.target.value;
      if (num) {
        const value = ValidationUtils.unformat(num);
        if (ValidationUtils.isNumberOrEmpty(value)) {
          this.setState({
            montoAdeudado: value,
          });
        }
      } else {
        this.setState({
          montoMaximoDeuda: num,
        });
      }
    };

    onChangeTipoProducto = (combo, value, label) => {
      this.setState({ tipoProducto: { codProducto: value, nombreProducto: label } });
    };

    isFormComplete = () => {
      let result = false;
      if (this.state.tipoProducto.codProducto) {
        if (this.state.compromete === SI) {
          result = this.state.montoMaximoDeuda > 0;
        } else if (this.state.compromete === NO) {
          result = true;
        }
      }
      return result;
    };

    onChangeCompromete = (evt) => {
      const value = evt.target.value;
      this.setState({ compromete: value });
    };

    renderCompromisoDeuda(compromete) {
      let ingresoCompromisoDeuda;
      let noClass = 'none';
      let siClass = 'none';
      if (compromete === SI) {
        ingresoCompromisoDeuda = (
          <div className="contenedorTextRipley contenedorMonto">
            <TextRipleyComponent
              className="TextRipley"
              label="Monto máximo Deuda"
              onChange={this.onChangeMontoMaximoDeuda}
              value={ValidationUtils.formatMonto(this.state.montoMaximoDeuda)}
              fullWidth={true}
            />
            <div className="peso">$</div>
          </div>
        );
        siClass = 'bordeDestacado';
      } else if (compromete === NO) {
        noClass = 'bordeDestacado';
      }
      return (
        <div className="compromisoDeuda">
          <Typography className="tituloStepSolicitud">
            ¿Puedes comprometerte a no aumentar la deuda de tu(s) tarjeta(s) de crédito y/o línea(s) de crédito?
            <IconButton color="primary" className="btnInfoCompromiso" onClick={this.onOpenExplicacion}>
              <Info />
            </IconButton>
          </Typography>
          <RadioGroup aria-label="gender" name="gender1" className="opcionesCompromiso" value={this.state.compromete} onChange={this.onChangeCompromete}>
            <FormControlLabel control={<Radio color="primary" />} label="me comprometo" className={siClass} value={SI} />
            <FormControlLabel control={<Radio color="primary" />} label="no me comprometo" className={noClass} value={NO} />
          </RadioGroup>
          {ingresoCompromisoDeuda}
          <ExplicacionCompromisoDeudaComponent
            open={this.state.openExplicacion}
            onClose={() => {
              this.setState({ openExplicacion: false });
            }}
          />
        </div>
      );
    }

    renderDetalleProducto = () => {
      let result;
      const tipoProducto = this.state.tipoProducto;
      if (tipoProducto.codProducto) {
        let producto;
        if (tipoProducto.codProducto === 'TARCRE') {
          producto = 'la tarjeta de crédito';
        } else if (tipoProducto.codProducto === 'LINCRE') {
          producto = 'la línea de crédito';
        }
        result = (
          <div>
            {this.renderCompromisoDeuda(this.state.compromete)}
            <div className="contenedorTextRipley">
              <TextRipleyComponent
                className="TextRipley"
                label={'Identificación de la cuenta (Últimos ' + NUM_CUENTA_MAX_LENGTH + ' dígitos de ' + producto + ')'}
                fullWidth={true}
                onChange={this.onChangeNumCuenta}
                value={this.state.numeroCuenta}
                error={this.state.errorNumeroCuenta}
                errorText={this.state.errortxtNumeroCuenta}
                placeholder="(opcional)"
              />
            </div>
          </div>
        );
      }
      return result;
    };
    render = () => {
      const disableContinuar = !this.isFormComplete();
      return (
        <div className="bloqueSeleccionBanco">
          <div className="stepSolicitud">
            <Typography className="tituloStepSolicitud ">
              Elige tu <strong>tarjeta o línea de crédito</strong> e ingresa el detalle. Presiona el boton <strong>"Agregar Producto"</strong> para agregarlo a tu bolsa de portabilidad
            </Typography>
          </div>
          <div className="autoCompletar">
            <label className="labelSelect">Tipo de Producto</label>
            <AutoCompletar
              options={this.props.listaTiposProductos}
              placeholder="seleccione el tipo de producto"
              nomCombo="cmbTiposCuentas"
              valor={this.state.tipoProducto.codProducto}
              handleChange={this.onChangeTipoProducto}
            ></AutoCompletar>
          </div>
          {this.renderDetalleProducto()}
          <div className="botones">
            <Button color="primary" id="btnAgregar" className="btnRipley" fullWidth={true} onClick={this.onAgregar} disabled={disableContinuar}>
              Agregar Producto
            </Button>
          </div>
          <Dialog open={false}>
            <DialogContent>
              <div className="cerrarBtnModal">
                <IconButton onClick={this.closeDetalle}>
                  <Close></Close>
                </IconButton>
              </div>
              <Typography className="tituloModalCarnet">Compromiso de deuda</Typography>
              <Typography>
                Debes indicar el monto máximo del cupo de tu tarjeta o línea de crédito el cual deseas utilizar antes de realizar la portabilidad de tu producto. Con este compromiso, nos das las
                facultades para que pidamos a tu banco actual que bloqueen tu Tarjeta de crédito o Línea de crédito con el fin de no aumentar tu deuda. En caso de no cumplimiento del compromiso por
                parte del solicitante, Banco Ripley puede retractarse de la oferta, incluso cuando ésta ya haya sido aceptada por el cliente.
              </Typography>
            </DialogContent>
            <div>
              <div className="franjaColores">
                <div className="rojo" />
                <div className="amarillo" />
                <div className="morado" />
              </div>
            </div>
          </Dialog>
        </div>
      );
    };
  }
);

export default component;
